import {aggregates, urlQueryStringBuilder} from '@utils/constantHelpers'
import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    openProcesses: {},
    openProcess: null,
    identification: {
      identificationNumber: '',
      documentType: '',
    },
    agreementSalary: {},
    resultExceptions: [],
    sapHiringRecords: [],
    invitation: false,
    verifyInvitationData: {
      token: '',
      identificationNumber: '',
    },
    endOfContractDocument: null,
    notPassedTrialDocument: null,
    cityBonusDocument: null,
    conversionDocument: null,
    extensionDocument: null,
    mutationDocument: null,
    hourRate: null,
    meanWeeksPerMonth: null,
    signaturePendingContractCollaborator: null,
  }
}
const statusOrder = [
  'STATUS_WAITING_FOR_ADDRESS_DATA',
  'STATUS_WAITING_FOR_FISCAL_DATA',
  'STATUS_WAITING_FOR_BANK_DATA',
  'STATUS_WAITING_FOR_LABOR_DATA',
  'STATUS_WAITING_FOR_OSMOS_RESPONSE',
  'ABORTED',
  'COMPLETED_SUCCESS'
];
export const state = getDefaultState()

export const getters = {
  IS_INVITATION(state) {
    return state.invitation
  },
}

export const mutations = {
  UPDATE_OPEN_PROCESS(state, openProcess) {
    if ({}.hasOwnProperty.call(openProcess, 'exceptions')) {
      state.openProcess = null
    } else {
      state.openProcess = openProcess
    }
  },
  UPDATE_OPEN_PROCESSES(state, openProcesses) {
    state.openProcesses = openProcesses
  },
  UPDATE_AGREED_SALARY(state, agreementSalary) {
    state.agreementSalary = agreementSalary
  },
  UPDATE_IDENTIFICATION_NUMBER(state, identificationNumber) {
    state.identification.identificationNumber = identificationNumber
  },
  UPDATE_DOCUMENT_TYPE(state, documentType) {
    state.identification.documentType = documentType
  },
  UPDATE_VERIFICATION_DOCUMENT_TOKEN_DATA(
    state,
    { identificationNumber, token },
  ) {
    state.verifyInvitationData.identificationNumber = identificationNumber
    state.verifyInvitationData.token = token
  },
  UPDATE_END_OF_CONTRACT_DOCUMENT(state, endOfContractDocument) {
    state.endOfContractDocument = endOfContractDocument
  },
  UPDATE_NOT_PASSED_TRIAL_DOCUMENT(state, notPassedTrialDocument) {
    state.notPassedTrialDocument = notPassedTrialDocument
  },
  UPDATE_CITY_BONUS_DOCUMENT(state, cityBonusDocument) {
    state.cityBonusDocument = cityBonusDocument
  },
  UPDATE_CONVERSION_DOCUMENT(state, conversionDocument) {
    state.conversionDocument = conversionDocument
  },
  UPDATE_EXTENSION_DOCUMENT(state, extensionDocument) {
    state.extensionDocument = extensionDocument
  },
  UPDATE_MUTATION_DOCUMENT(state, mutationDocument) {
    state.mutationDocument = mutationDocument
  },
  RESET_CONTRACT_MANAGER_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  UPDATE_HOUR_RATE(state, hourRate) {
    state.hourRate = hourRate
  },
  MEAN_WEEKS_PER_MONTH(state, weeks) {
    state.meanWeeksPerMonth = weeks
  },
  START_INVITATION(state) {
    state.invitation = true
  },
  UPDATE_PENDING_CONTRACTS_PROCESSES_COLLABORATOR(
    state,
    signaturePendingContractCollaborator,
  ) {
    state.signaturePendingContractCollaborator =
      signaturePendingContractCollaborator
  },
}

export const actions = {
  // OPEN PROCESSES (FILTERS: OPENPROCESS ID, SITECODE)
  // GET
  async fetchOpenProcess(store, options = {}) {
    let url = `${BASE}/mx/api/v2/contractProcesses.common/${options.processUuid}`
    if (options.siteCode) {
      // Review
      url = `${BASE}/mx/api/v2/sites/${options.siteCode}/contractProcesses.common/${options.processUuid}`
    }
    if (options.withIndex) {
      url = `${url}?withIndex=true`
    }
    if (options.withProcessRoadmap) {
      url = `${url}?withProcessRoadmap=true`
    }
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_OPEN_PROCESS', res.data)
      return res
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error.message}`)
    }
  },
  // OPEN PROCESSES

  // CLEAR OPEN PROCESSES
  async resetOpenProcesses(store) {
    store.commit('UPDATE_OPEN_PROCESSES', {})
  },

  // GET
  async fetchOpenProcesses(store, payload = {}) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/contractProcesses.common${urlQueryStringBuilder(
          payload,
        )}`,
      )
      store.commit('UPDATE_OPEN_PROCESSES', res.data)
      return res
    } catch (error) {
      throw new Error(
        `API Error occurred in es/api/v2/contractProcesses.common${urlQueryStringBuilder(
          payload,
        )}.`,
      )
    }
  },
  // OPEN PROCESSES OF SITE
  // GET
  async fetchSiteOpenProcesses(store, payload = {}) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/sites/${
          payload.personnelDivision
        }/contractProcesses.common${urlQueryStringBuilder(payload)}`,
      )
      store.commit('UPDATE_OPEN_PROCESSES', res.data)

      if(res.data.data.length >= 1){
        const arr = res.data.data;
        arr.sort((a, b) => {
          return statusOrder.indexOf(a.currentStatus) - statusOrder.indexOf(b.currentStatus);
        });

        return arr
      }


    } catch (error) {
      throw new Error(
        `API Error occurred in mx/api/v2/sites/${
          payload.personnelDivision
        }/contractProcesses.common${urlQueryStringBuilder(payload)}.`,
      )
    }
  },
  // AGREED SALARY
  // GET
  async fetchAgreementSalary(store, code) {
    try {
      const res = await axios.get(`${BASE}/api/v2/parameters/code/${code}`)
      store.commit('UPDATE_AGREED_SALARY', res.data)
    } catch (error) {
      throw new Error(`API Error occurred at /api/v2/parameters/code/${code}`)
    }
  },
  // Hour rate
  // GET
  async fetchHourRate(store) {
    try {
      const res = await axios.get(
        `${BASE}/api/v2/parameters/code/MEX_HOUR_RATE`,
      )
      store.commit('UPDATE_HOUR_RATE', res.data.value)
      return res.data.value
    } catch (error) {
      throw new Error(
        `API Error occurred at /api/v2/parameters/code/MEX_HOUR_RATE`,
      )
    }
  },
  // Mean weeks per month
  // GET
  async fetchMeanWeeksPerMonth(store) {
    try {
      const res = await axios.get(
        `${BASE}/api/v2/parameters/code/MEAN_WEEKS_PER_MONTH`,
      )
      store.commit('MEAN_WEEKS_PER_MONTH', res.data.value)
      return res.data.value
    } catch (error) {
      throw new Error(
        `API Error occurred at /api/v2/parameters/code/MEAN_WEEKS_PER_MONTH`,
      )
    }
  },

  // END OF CONTRACT DOCUMENT
  // GET
  async fetchEndOfContractDocumentAction(store, collaboratorId) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/contracts/completion.notice.document/collaborator/${collaboratorId}`,
      )
      store.commit('UPDATE_END_OF_CONTRACT_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contracts/completion.notice.document/collaborator/${collaboratorId}`,
      )
    }
  },
  // NOT PASSED TRIAL DOCUMENT
  // GET
  async fetchNotPassedTrialDocumentAction(store, collaboratorId) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/contracts/not.passed.trial.notice.document/collaborator/${collaboratorId}`,
      )
      store.commit('UPDATE_NOT_PASSED_TRIAL_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contracts/not.passed.trial.notice.document/collaborator/${collaboratorId}`,
      )
    }
  },

  async fetchConversionDocumentAction(store, collaboratorUuid) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/contracts/document.conversion/collaborator/${collaboratorUuid}`,
      )
      store.commit('UPDATE_CONVERSION_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contracts/document.conversion/collaborator/${collaboratorUuid}`,
      )
    }
  },

  async fetchExtensionDocumentAction(store, collaboratorUuid) {
    try {
      const res = await axios.get(
        `${BASE}/mx/api/v2/contracts/document.extension/collaborator/${collaboratorUuid}`,
      )
      store.commit('UPDATE_EXTENSION_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contracts/document.extension/collaborator/${collaboratorUuid}`,
      )
    }
  },

  async fetchMutationDocumentAction(store, collaboratorUuid, training = false) {
    const url =
      `${BASE}/mx/api/v2/contracts/document.mutation/collaborator/${collaboratorUuid}?training=` +
      training
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_MUTATION_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}`)
    }
  },

  async fetchCityBonusDocumentAction(store, collaboratorUuid) {
    const url = `${BASE}/mx/api/v2/contracts/document.city_bonus/collaborator/${collaboratorUuid}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_CITY_BONUS_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}`)
    }
  },

  // //////
  // POST
  // //////

  // HIRING
  // CHECK ID before start Hiring
  async checkId({ commit }, payload) {
    try {
      const response = await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.checkId`,
        payload,
      )
      commit(
        'UPDATE_IDENTIFICATION_NUMBER',
        payload.identificationDto.personalIdentificationNumber,
      )
      commit(
        'UPDATE_DOCUMENT_TYPE',
        payload.identificationDto.identificationDocumentType,
      )
      return response
    } catch (e) {
      throw Error('API Error occurred in api/checkId.')
    }
  },
  // POST ID + TOKEN
  async postIdToken({ commit }, payload) {
    try {
      const response = await axios.post(
        `${BASE}/mx/api/v2/verifyInvitation`,
        payload,
      )
      if (response.data.success) {
        commit('UPDATE_VERIFICATION_DOCUMENT_TOKEN_DATA', {
          identificationNumber: payload.rfc,
          token: payload.token,
        })
        commit(
          'collaborator/UPDATE_COLLABORATOR',
          response.data.aggregates.collaborator,
          { root: true },
        )
      }
      return response
    } catch (e) {
      throw Error(
        `API Error occurred in /api/v2/contractManager/verifyInvitation.`,
      )
    }
  },

  // NEW HIRING
  async startHiringProcessAction(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.startHiringProcess`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.startHiringProcess.`,
      )
    }
  },

  async hiringProcessGetAddressAction(store, payload) {
    try {
      const url = `${BASE}/mx/api/v2/contractManager/hiring.getAddress`
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.getAddress.`,
      )
    }
  },

  async hiringProcessGetFiscalDataAction(store, payload) {
    try {
      const url = `${BASE}/mx/api/v2/contractManager/hiring.getFiscalData`
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.getFiscalData.`,
      )
    }
  },

  async hiringProcessGetLaborDataAction(store, payload) {
    try {
      const url = `${BASE}/mx/api/v2/contractManager/hiring.getLaborData`
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.getLaborData.`,
      )
    }
  },

  async hiringProcessGetBankDataAction(store, payload) {
    try {
      const url = `${BASE}/mx/api/v2/contractManager/hiring.getBankData`
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.getBankData.`,
      )
    }
  },

  // Notify hiring process notifyHiringProcess
  async notifyHiringProcess(store,  payload ) {
    const url = `${BASE}/mx/api/v2/contractManager/hiring.notifyHiringProcess`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ${url}`)
    }
  },

  // REHIRING
  async rehiringProcessGetPersonalDataAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/rehiring.getPersonalData`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ` + url)
    }
  },

  async rehiringProcessGetAddressDataAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/rehiring.getAddressData`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ` + url)
    }
  },

  async rehiringProcessGetFiscalDataAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/rehiring.getFiscalData`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ` + url)
    }
  },

  async rehiringProcessGetBankDataAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/rehiring.getBankData`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ` + url)
    }
  },

  async rehiringProcessGetLaborDataAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/rehiring.getLaborData`
    try {
      return await axios.post(url, payload)
    } catch (e) {
      throw Error(`API Error occurred at ` + url)
    }
  },

  // EDIT RectifyHIRING PROCESS
  async editRectifyHiringProcess(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.rectify`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at api/v2/contractManager/hiring.startHiringProcess.`,
      )
    }
  },

  // EDIT HIRING PROCESS
  async editHiringProcess(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.edit`,
        payload,
      )
    } catch (e) {
      throw Error(`API Error occurred at api/v2/contractManager/hiring.edit.`)
    }
  },

  // VALIDATE PROCESS
  async validateProcess(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/common.validateProcess`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/common.validateProcess.`,
      )
    }
  },

  // ABORT HIRING CONTRACT PROCESS
  async abortProcess(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.abortHiringProcess`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/hiring.abortHiringProcess.`,
      )
    }
  },

  // CANCEL HIRING CONTRACT PROCESS
  async cancelContractProcess(store, payload) {
    const aggregate = aggregates[payload.processType]

    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/${aggregate}.cancelProcess`,
        payload.command,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/${aggregate}.cancelProcess.`,
      )
    }
  },

  // sendEmail to Collaborator with link to enter personal in first steps of hiring contract process
  async sendEmailCollaboratorStart(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.sendEmailCollaboratorToken`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/hiring.sendEmailCollaboratorToken.`,
      )
    }
  },

  // POST PERSONAL AND ADDRESS DATA, HIRING PROCESS
  async insertCollaboratorData(store, command) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.insertPersonalData`,
        command,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/api/v2/contractManager/hiring.insertPersonalData`,
      )
    }
  },
  // CREATE COLLABORATOR IN IDENTITY ACCESS
  async createCollaboratorIdentityAccess(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.createCollaboratorIdentityAccess`,
        payload,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/api/v2/contractManager/hiring.createCollaboratorIdentityAccess`,
      )
    }
  },
  // POST MANUALLY OBTAINED USERNAME AND EMAIL IF IDENTITY ACCESS
  async manualAssignIdentity(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.manualAssignIdentity`,
        payload,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in /mx/api/v2/contractManager/hiring.manualAssignIdentity`,
      )
    }
  },

  // SIGN PROCESS IN PAPER
  async signOnPaperAction(store, payload) {
    let path
    switch (payload.processType) {
      case 'HIRING_CONTRACT_PROCESS_MEX':
        path = 'hiring'
        break
      case 'CONVERSION_CONTRACT_PROCESS_MEX':
        path = 'conversion'
        break
      case 'REHIRING_CONTRACT_PROCESS_MEX':
        path = 'hiring.rehiringProcess'
        break
      case 'EXTENSION_CONTRACT_PROCESS_MEX':
        path = 'extension'
        break
    }

    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/${path}.signOnPaper`,
        payload.command,
      )
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contractManager/${path}.signOnPaper`,
      )
    }
  },

  // REHIRING
  // START REHIRING PROCESS

  async startRehiringProcessAction(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/hiring.startRehiringProcess`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/hiring.startRehiringProcess.`,
      )
    }
  },

  // LEAVE OF ABSENCE RE-ENTRY
  async leaveOfAbsenceReEntryAction(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/leave.startRehiringLeaveOfAbsence`,
        payload,
      )
    } catch (e) {
      throw Error(
        `API Error occurred at /mx/api/v2/contractManager/leave.startRehiringLeaveOfAbsence.`,
      )
    }
  },

  // CONTRACT EXTENSION
  // POST
  async extendContractAction(store, payload) {
    try {
      return await axios.post(
        `${BASE}/mx/api/v2/contractManager/extension.startProcess`,
        payload,
      )
    } catch (error) {
      throw new Error(
        `API Error ocurred in /mx/api/v2/contractManager/extension.startProcess: ${error}`,
      )
    }
  },

  // SIGNATURE PENDING CONTRACT PROCESSES COLLABORATOR
  // GET
  async fetchSignaturePendingContractCollaborator(store) {
    try {
      store.commit('UPDATE_PENDING_CONTRACTS_PROCESSES_COLLABORATOR', null)
      const res = await axios.get(
        `${BASE}/mx/api/v2/contractManager/collaborator.signaturePendingContractProcesses`,
      )
      store.commit('UPDATE_PENDING_CONTRACTS_PROCESSES_COLLABORATOR', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contractManager/collaborator.signaturePendingContractProcesses`,
      )
    }
  },
  // FORCE COMPLETE PROCESS
  // POST
  async forceCompleteProcessAction(store, payload) {
    const url = `${BASE}/mx/api/v2/contractManager/force.complete`
    try {
      return await axios.post(url, payload)
    } catch (error) {
      throw new Error(`API Error occurred in ${url}: ${error}`)
    }
  },
}
